<template>
	<div class="ooo-wrapper">
		<div class="ooo-container" v-bind:class="{ empty: staff.length === 0 }">
			<div class="nobody-out" v-if="staff.length === 0">
				<div class="text">Nobody is out today!</div>
			</div>
			<h2 v-else>Out Today</h2>
			<ul class="staff-wrapper">
				<li class="staff" v-for="s in staff" v-bind:key="s.employeeId">
					<img v-bind:src="'/staff/image?id=' + s.employeeId" />
					<span class="text">{{s.firstName}}</span>
				</li>
			</ul>
		</div>

	</div>
</template>

<script>
	import Bugsnag from '@bugsnag/js'

	let staffOoo = null;

	export default {
		name: 'DevOoo',

		data() {
			return {
				staff: []
			};
		},

		mounted() {
			console.log("Development out-of-office module initiated");
			this.refreshOutOfOffice();
			staffOoo = setInterval(this.refreshOutOfOffice, 600000);
		},
		
		destroyed() {
			console.log("Stopping Development out-of-office module");
			clearInterval(staffOoo);
		},
		
		methods: {

			refreshOutOfOffice() {
				let self = this;
				self.$http.get('/staff/ooo', {}).then(response => {
					let data = response.body;
					self.staff = data;
				}).catch(e => {
					Bugsnag.notify(new Error(e.url), function (event) {
						event.addMetadata('httpResponse', e);
					});
					console.error(e);
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	@import '../../less/_variables.less';

	@bg-ooo: #444;

	.ooo-wrapper {
		width: 100%;
		height: 45%;
		font-family: @font-main;
	}
	
	h2 {
		text-align: center;
		text-transform: uppercase;
		font-size: 1.5em;
		line-height: 1em;
		margin: 0 0 0.5em;
	}

	.ooo-container {
		background-color: @bg-ooo;
		border-radius: @border-radius;
		height: 100%;
		padding: 1em;
		color: #fff;
		overflow: hidden;

		&.empty {
			background-image: url(images/logo-bkg.svg);
			background-size: contain;
			background-position: center center;
			background-repeat: no-repeat;
			background-origin: content-box;
		}

		.nobody-out {
			width: 100%;
			height: 100%;
			display: flex;
			justify-content: center;
			align-items: center;

			.text {
				font-size: 1.5em;
				line-height: 1.4em;
				text-align: center;
			}
		}

		.staff-wrapper {
			//column-count: 2;
			//column-width: auto;
			list-style: none;
			margin: 0;
			padding: 0;
		}

		.staff {
			padding: 0.25em 0.5em;
			font-size: 1.25em;
			height: 1.65em;
			line-height: 1em;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			img {
				width: auto;
				height: 1.45em;
				border-radius: 100%;
			}

			.text {
				padding: 0 0 0 0.5em;
				font-weight: 300;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// mini-ooo.vue?2fe297d3